import ClosedCaptions from './closed_captions'
export default ClosedCaptions



// WEBPACK FOOTER //
// ./src/plugins/closed_captions/index.js